// Registers the federated runtime remotes from app settings; the only config module importing the MF runtime.
import { registerRemotes } from '@module-federation/enhanced/runtime';

const RUNTIME_REMOTES = [
  { name: 'shipbob_design_system', settingKey: 'SHIPBOB_DESIGN_SYSTEM', required: true },
  { name: 'shipbob_mfe_runtime', settingKey: 'SHIPBOB_MFE_RUNTIME', required: true },
];

/** A remote origin must be an absolute http(s) URL — anything else (relative path,
 *  other scheme, garbage) would load remoteEntry.js from an unintended location. */
function isValidRemoteOrigin(value) {
  if (typeof value !== 'string' || !value.trim()) return false;
  try {
    const url = new URL(value.trim());
    return url.protocol === 'https:' || url.protocol === 'http:';
  } catch (error) {
    return false;
  }
}

/** Register every runtime remote from app settings; returns false (registering nothing) if any
 *  required remote's URL is missing/invalid — validate-then-register keeps the failure path
 *  atomic, so the MF runtime is never left partially registered when prepareRuntime throws. */
export function registerRuntimeRemotes(appSettings) {
  const settings = appSettings || {};
  const missingRequired = [];
  const validRemotes = [];

  RUNTIME_REMOTES.forEach(({ name, settingKey, required }) => {
    const value = settings[settingKey];
    if (!isValidRemoteOrigin(value)) {
      console.error(
        `[receiving-ui] ${settingKey} missing or not an absolute http(s) URL; `
        + `${required ? 'cannot register' : 'skipping'} ${name} remote`,
      );
      if (required) missingRequired.push(settingKey);
      return;
    }
    const origin = value.trim().replace(/\/+$/, '');
    validRemotes.push({ name, entry: `${origin}/remoteEntry.js` });
  });

  if (missingRequired.length) return false;

  validRemotes.forEach((remote) => registerRemotes([remote], { force: true }));
  return true;
}
